import { upperFirst } from 'lodash';
import { UserCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import useStore from '../../../../store';
import { LandlordBooking, TenantBooking } from '../../../../types/bookings';
import {
  StyledSection,
  StyledSectionTitle,
  StyledSectionTitleWrapper,
} from '../BookingInformation.styles';
import BookingLandlordUserInformation from './BookingLandlordUserInformation';
import BookingTenantUserInformation from './BookingTenantUserInformation';

interface BookingUserInformationProps {
  booking: LandlordBooking | TenantBooking;
}

const BookingUserInformation = ({ booking }: BookingUserInformationProps) => {
  const { t } = useTranslation(['booking', 'form']);
  const { user } = useStore(state => ({
    user: state.user,
  }));
  return (
    <StyledSection>
      <StyledSectionTitleWrapper user={user?.type}>
        <UserCircle size={20} />
        <StyledSectionTitle>
          {upperFirst(t('booking:tenantInformation'))}
        </StyledSectionTitle>
      </StyledSectionTitleWrapper>
      {user?.type === 'landlord' && (
        <BookingLandlordUserInformation
          tenantFirstName={booking?.tenant.name.first_name}
          tenantLastName={booking?.tenant.name.last_name}
          tenantOccupation={booking?.tenant.occupation}
          tenantAge={booking?.tenant.age}
          tenantComment={booking?.tenant.comment}
        />
      )}
      {user?.type === 'tenant' && (
        <BookingTenantUserInformation
          tenantFirstName={booking?.tenant.name.first_name}
          tenantLastName={booking?.tenant.name.last_name}
          tenantOccupation={booking?.tenant.occupation}
          tenantAge={booking?.tenant.age}
          tenantComment={booking?.tenant.comment}
        />
      )}
    </StyledSection>
  );
};

export default BookingUserInformation;
